import {
  $ArithmeticOperation,
  $ModuleArea,
  ModuleArea,
} from '@suntex.fim/enums';

import { NodeModel } from '../../../types';

const moduleAreaDesc = $ModuleArea.describe(ModuleArea.VeryImportantFacts);

export const vifNode: NodeModel = {
  tag: moduleAreaDesc.slug,
  info: {
    title: moduleAreaDesc.label,
  },
  label: {
    aria: moduleAreaDesc.label,
    class: 'MainLabel',
    frame: 9,
  },
  color: moduleAreaDesc.color,
  layout: 'operations',
  children: $ArithmeticOperation.describeAll().map((op) => ({
    moduleSlug: `vif-${op.slug}`,
    dataPath: ['vif', op.slug],
    href: `/modules/vif/${op.slug}`,
    icon: `operations/${op.slug}`,
    label: {
      aria: op.label,
    },
    filtered: {
      icon: `alts/vif-${op.slug}`,
      label: `VIF ${op.label}`,
      color: moduleAreaDesc.color,
    },
    color: op.color,
  })),
};
